import { render, staticRenderFns } from "./historyC.vue?vue&type=template&id=d9551396&scoped=true"
import script from "./historyC.vue?vue&type=script&lang=js"
export * from "./historyC.vue?vue&type=script&lang=js"
import style0 from "./historyC.vue?vue&type=style&index=0&id=d9551396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9551396",
  null
  
)

export default component.exports